import * as Sentry from '@sentry/react';
import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { APP_PREFIX } from '@/shared/constants/app-prefix.constant';
import { USER_DOMAIN } from '@/shared/constants/user-domain.constant';
import { useAppPrefix } from '@/shared/lib/hooks/use-app-prefix.hook';
import { PageLoader } from '@/widgets/page';

import { SectorRoutes } from '../sector-routers';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(({ children }) => <Routes>{children}</Routes>);

const RouterComponent = () => {
	const sectorPrefix = useAppPrefix();

	return (
		<SentryRoutes>
			<Route path="/" element={<Navigate to={sectorPrefix} replace />} />

			<Route
				path={`${APP_PREFIX[USER_DOMAIN.YACHTING]}/*`}
				element={
					<Suspense fallback={<PageLoader />}>
						<SectorRoutes />
					</Suspense>
				}
			/>
			<Route
				path={`${APP_PREFIX[USER_DOMAIN.INDUSTRIAL]}/*`}
				element={
					<Suspense fallback={<PageLoader />}>
						<SectorRoutes />
					</Suspense>
				}
			/>
		</SentryRoutes>
	);
};

export default RouterComponent;
